// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"605":"582c2eb9","819":"20298afc","949":"e25664f8","988":"5791a3ce","990":"541a5907"}[chunkId] + ".chunk.js";
};